import { render, staticRenderFns } from "./CommonRadioButtonBox.vue?vue&type=template&id=280baccd"
import script from "./CommonRadioButtonBox.vue?vue&type=script&lang=js"
export * from "./CommonRadioButtonBox.vue?vue&type=script&lang=js"
import style0 from "./CommonRadioButtonBox.vue?vue&type=style&index=0&id=280baccd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports